import ModalBase from './modalBase';
import React, { useState, useEffect } from 'react';
import { getTranslations } from '../../../../../../services/languageUtils';

function ModalKeysInfo({ show, onClose }){
  const [translations, setTranslations] = useState({});

  useEffect(() => {
    const loadTranslations = async () => {
      const trans = await getTranslations((localStorage.getItem('language') || 'pt'));
      setTranslations(trans);
    };
    loadTranslations();
  }, []);
  return (
    <ModalBase show={show} onClose={onClose}>
      <h1 className="text-2xl font-bold text-center">{translations.important_notes}</h1><br/>
      <p><b>{translations.types}</b> - {translations.cell_phone_number}, {translations.email}, {translations.cpf_cnpj}, {translations.random_key}</p>
      <p><b>{translations.restriction}</b> - {translations.each_key_only_one_account}</p>
      <p><b>{translations.limit}</b> - {translations.up_to_5_keys}</p><br/>
      <button
        onClick={onClose}
        className="w-full px-4 py-2 bg-customGreen text-white rounded hover:bg-customGreenHover"
      >
        {translations.proceed}
      </button>
    </ModalBase>
  );
}

export default ModalKeysInfo;
